import React, { Component } from "react"
import { fetchLookupParentsChild } from "../../actions/lookup_parents_action"
import { setErrorFields } from "../../helpers/validationHelpers"
import Notification from "../layout/Notification"
import { MESSAGE, NODE_ENV } from "../../config/index"
import { getAll } from "../../services/item.service"
import { getAll as getCopies } from "../../services/item_copies.service"
import { API_URL, S3 } from "../../config/urls"
import route from "../../config/routes"
import Service from "../../helpers/service"
import Helping from "../../helpers/Helping"
import LoadingButton from "../fields/LoadingButton"
import { connect } from "react-redux"
import $ from "jquery"
import CSVReader from "react-csv-reader"
const { EMPTY, IMPORT } = MESSAGE

class CreateJSON extends Component {
  paths = {
    pacificrim: {
      itemModelPath: "/legendary/models/3d/",
      itemImgPath: "/legendary/models/images/",
      itemThumbnailVideoPath: "/legendary/models/thumbnail_video/",
    },
    vflect: {
      itemModelPath: "/terravirtua/models/3d/",
      itemImgPath: "/terravirtua/models/images/",
      itemThumbnailVideoPath: "/terravirtua/models/thumbnail_video/",
    },
    los: {
      itemModelPath: "/legendary/models/3d/",
      itemImgPath: "/legendary/models/images/",
      itemThumbnailVideoPath: "/legendary/models/thumbnail_video/",
    },
    topgun: {
      itemModelPath: "/paramount/models/3d/",
      itemImgPath: "/paramount/models/images/",
      itemThumbnailVideoPath: "/paramount/models/thumbnail_video/",
    },
    godfather: {
      itemModelPath: "/paramount/models/3d/",
      itemImgPath: "/paramount/posters/images/",
      itemThumbnailVideoPath: "/paramount/posters/thumbnail_video/",
    },
    sunset: {
      itemModelPath: "/paramount/posters/3d/",
      itemImgPath: "/paramount/posters/images/",
      itemThumbnailVideoPath: "/paramount/posters/thumbnail_video/",
    },
    comics: {
      itemModelPath: "/terravirtuacomics/3d/",
      itemImgPath: "/terravirtuacomics/images/",
      itemThumbnailVideoPath: "/terravirtuacomics/thumbnail_video/",
    },
    tva: {
      itemModelPath: "/terravirtuaart/3d/",
      itemImgPath: "/terravirtuaart/images/",
      itemThumbnailVideoPath: "/terravirtuaart/thumbnail_video/",
    },
    amrita: {
      itemModelPath: "/terravirtuaart/3d/",
      itemImgPath: "/terravirtuaart/images/",
      itemThumbnailVideoPath: "/terravirtuaart/thumbnail_video/",
    },
    aswaa: {
      itemModelPath: "/terravirtuaart/3d/",
      itemImgPath: "/terravirtuaart/images/",
      itemThumbnailVideoPath: "/terravirtuaart/thumbnail_video/",
    },
    nerds: {
      itemModelPath: "/nerdsclothing/3d/",
      itemImgPath: "/nerdsclothing/images/",
    },
    godzilla_vs_kong: {
      itemModelPath: "/legendary/models/3d/",
      itemImgPath: "/legendary/models/images/",
      itemThumbnailVideoPath: "/legendary/models/thumbnail_video/",
    },
    dynamite: {
      itemModelPath: "/dynamite/3d/",
      itemImgPath: "/dynamite/images/",
      itemThumbnailVideoPath: "/dynamite/thumbnail_video/",
    },
    locgame: {
      itemModelPath: "/locgame/3d/",
      itemImgPath: "/locgame/images/",
      itemThumbnailVideoPath: "/locgame/thumbnail_video/",
    },
    redbullracing: {
      itemModelPath: "/redbullracing/3d/",
      itemImgPath: "/redbullracing/images/",
      itemThumbnailVideoPath: "/redbullracing/thumbnail_video/",
    },
    cardano: {
      itemModelPath: "/cardano/3d/",
      itemImgPath: "/cardano/images/",
      itemThumbnailVideoPath: "/cardano/thumbnail_video/",
    },
    isl: {
      itemModelPath: "/isl/3d/vr/updated/",
      itemImgPath: "/isl/images/",
      itemThumbnailVideoPath: "/isl/thumbnail_video/",
    },
    
    nitroleague: {
      itemModelPath: "/nitroleague/3d/",
      itemImgPath: "/nitroleague/images/",
      itemThumbnailVideoPath: "/nitroleague/thumbnail_video/",
    },
    deathmerchant: {
      itemModelPath: "/deathmerchant/3d/",
      itemImgPath: "/deathmerchant/images/",
      itemThumbnailVideoPath: "/deathmerchant/thumbnail_video/",
    },
  }

  constructor (props, context) {
    super(props, context)

    this.state = {
      currentSheet: "none",
      currentENV: "",
      lookup_id: "",
      waitingForLookups: true,
      isSetLookupsLocked: true,
      SetLookupsActionStatus: "",
      textToCopy: "",
      theInputKey: 0,
      copyJson: false,
      lookupsToAdd: [],
      items: [],
      fields: [],
      ERRORS: [],
      jsonData: "",
      allBrands: [],
      url: API_URL.ADMIN_TRADING_API + route.IMPORT_ITEMS,
      btnIsDisable: false,
      fileInfo: "",
      error_message: "",
      error_type: "",
      isLoading: true,
      sorting: "id",
      sort_type: "DESC",
    }
    this.onSave = this.onSave.bind(this)
  }

  componentDidMount() {
    this.setState({ isLoading: false, currentENV: S3.URL })
    this.getLookups()
  }

  getItems() {
    this.props.getAll(
      this.props.page,
      this.props.limit,
      this.props.search.trim(),
      this.state.sorting,
      this.state.sort_type
    )
  }

  getCopies() {
    this.props.getCopies(
      this.props.copiesPage,
      this.props.copiesLimit,
      this.props.copiesSearch.trim(),
      this.state.sorting,
      this.state.sort_type
    )
  }

  getLookups = () => {
    this.props.fetchLookupParentsChild()
  }

  onFileTypeSelection = (event) => {
    event.preventDefault()
    this.setState({
      currentSheet: event.target.value,
      waitingForLookups: false,
    })
  }

  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    })
  }

  defaultFields = [
    "code",
    "name",
    "price",
    "mint_count",
    "Extension",
    "Thumbnail",
    "Chain",
  ]
  // otherFields = [
  //   "Description",
  //   "Brand",
  //   "Asset",
  //   "Extension",
  //   "s3_file_name",
  //   "DLC_Type",
  //   "Medium_Thumbnail",
  // ];

  redirectToItemList = () => {
    this.props.history.push(route.LIST_NFT)
  }

  checkIfHeadersAvailable() {
    var errorsObj = []

    this.defaultFields.map((field) => {
      let fieldFound = this.state.fields.includes(field.toLowerCase())

      if (!fieldFound) {
        errorsObj.push(`Header Not Found in CSV : <span>${field}</span>`)
      }
    })

    if (errorsObj.length > 0) {
      this.setState({ ERRORS: errorsObj })
      return false
    }

    return true
  }

  checkIfCodeOK(allTrueITems) {
    for (var a = 0; a < allTrueITems.length; a++) { }
  }

  lowercaseObj(obj) {
    return Object.keys(obj).reduce(
      (c, k) => ((c[k.toLowerCase().trim()] = obj[k]), c),
      {}
    )
  }

  fieldsToRead = [
    "code",
    "name",
    "price",
    "mint_count",
    "Extension",
    "Thumbnail",
    "Description",
    "Brand",
    "Asset",
    "Extension",
    "s3_file_name",
    "DLC_Type",
    "Medium_Thumbnail",
    "Rarity",
    "Type",
    "Chain",
    "Illustrator_Name",
    "Writer_Name",
    "sketchfab_id",
  ]

  checkEmptyFields = () => {
    let { state } = this
    let formHasError = false

    if (state.textToCopy.length === 0) {
      let errorObject = setErrorFields(
        "items",
        Helping.getMessageString(EMPTY, "Items")
      )
      this.setState({ ...errorObject })
      formHasError = true
    }
    return formHasError
  }

  removeNetworkError = () => {
    this.setState({ ...Helping.clearNetworkRequest() });
  }

  onSave(e) {
    e.preventDefault();

    this.setState({
      btnIsDisable: true
    })

    let data = {
      action: "import",
      items: JSON.parse(this.state.textToCopy),
    }
    return Service.postCall(this.state.url, data)
      .then((response) => {
        if (response.data.status === 200) {
          this.resetForm()
          this.setState(
            {
              error_message: Helping.getMessageString(IMPORT, "NFTs"),
              error_type: "success",
              btnIsDisable: false
            },
            () => {
              this.scrollToTop()
              this.getItems()
              this.getCopies()
            }
          )
        }
      })
      .catch((error) => {
        if (error.response) {
          Helping.redirectToLogin(error)
          return this.setState(
            {
              error_message: error.response.data.message,
              error_type: "danger",
              btnIsDisable: false,
            },
            () => {
              this.scrollToTop()
            }
          )
        }
        return this.setState(
          {
            btnIsDisable: false,
            ...Helping.setNetworkRequestError(error, "importing nfts"),
          },
          () => {
            this.scrollToTop()
          }
        )
      })
  }

  handleHeader = (header) => {
    const fieldName = header.toLowerCase().replace(/\W/g, "_")
    this.setState({
      fields: [...this.state.fields, fieldName],
    })
    return fieldName
  }

  handleForce = (data, fileInfo) => {
    this.setState({ fileInfo });

    if (!this.checkIfHeadersAvailable()) {
      this.setState({
        copyJson: false,
        textToCopy: "",
      })
      return
    }

    var trueItems = data.filter((item) => {
      return item.status === true
    })

    this.setState(
      {
        items: trueItems,
      },
      () => this.fillUpData()
    )
  }

  fillUpData = () => {
    var baseURL = this.state.currentENV
    var trueItems = this.state.items
    var items = []

    var { itemModelPath, itemImgPath, itemThumbnailVideoPath } =
      this.paths[this.state.currentSheet]

    for (var a = 0; a < trueItems.length; a++) {
      var itemToAdd = {}
      var rawItem = trueItems[a] //lower case all the keys

      // console.log(rawItem, "raw Items")

      itemToAdd["code"] = rawItem["code"]
        ? rawItem["code"].toLowerCase().trim()
        : this.setState({
          error_message: "Code is required",
          error_type: "danger",
        })
      itemToAdd["name"] = rawItem["name"]
        ? rawItem["name"].trim()
        : this.setState({
          error_message: "Item 'Name' is missing",
          error_type: "danger",
        })
      itemToAdd["which_bc"] = rawItem["chain"]
        ? rawItem["chain"].toUpperCase().trim()
        : this.setState({
          error_message: "Chain is missing",
          error_type: "danger",
        })
      itemToAdd["sketchfab_id"] = rawItem["sketchfab_id"]
        ? rawItem["sketchfab_id"]
        : null
      itemToAdd["generation"] = rawItem["generation"]
        ? rawItem["generation"]
        : "Gen2"

      itemToAdd["bundle_type"] = rawItem["bundle_type"]
        ? rawItem["bundle_type"]
        : "NONE"

      itemToAdd["movie_url"] = rawItem["movie_url"]
        ? rawItem["movie_url"]
        : null

      itemToAdd["bundle_item_child"] = rawItem["bundle_item_child"]
        ? rawItem["bundle_item_child"]
        : []

      itemToAdd["description"] = rawItem["description"]
        ? rawItem["description"]
        : ""

      itemToAdd["number_minted"] = rawItem["mint_count"]
        ? rawItem["mint_count"]
        : this.setState({
          error_message: "Mint Count is missing",
          error_type: "danger",
        })
      itemToAdd["unitValue"] = rawItem["price"]
        ? !isNaN(rawItem["price"])
          ? rawItem["price"]
          : 0
        : 0
      itemToAdd["video_url"] = rawItem["youtube"] ? rawItem["youtube"] : null

      // itemToAdd["writer_name"] = rawItem["writer_name"]
      //   ? rawItem["writer_name"]
      //   : null
      // itemToAdd["illustrator_name"] = rawItem["illustrator_name"]
      //   ? rawItem["illustrator_name"]
      //   : null

      if (rawItem["illustrator_name"]) {
        itemToAdd["illustrator_id"] = this.findID(
          this.props.illustrator,
          rawItem["illustrator_name"],
          "ILLUSTRATOR",
          a,
          "illustrator_id"
        )
      }
      if (rawItem["writer_name"]) {
        itemToAdd["writer_id"] = this.findID(
          this.props.writer,
          rawItem["writer_name"],
          "WRITER",
          a,
          "writer_id"
        )
      }
      if (rawItem["rarity"]) {
        itemToAdd["rarity_id"] = this.findID(
          this.props.rarities,
          rawItem["rarity"],
          "RARITY",
          a,
          "rarity_id"
        )
      }

      if (rawItem["type"]) {
        itemToAdd["type_id"] = this.findID(
          this.props.types,
          rawItem["type"],
          "TYPE",
          a,
          "type_id"
        )
      }

      if (rawItem["variation"]) {
        itemToAdd["variation_id"] = this.findID(
          this.props.variations,
          rawItem["variation"],
          "VARIATION",
          a,
          "variation_id"
        )
      }

      if (rawItem["category"]) {
        itemToAdd["category_id"] = this.findID(
          this.props.categories,
          rawItem["category"],
          "CATEGORY",
          a,
          "category_id"
        )
      }

      // if (rawItem["nft_type"]) {
      rawItem["nft_type"]
        ? (itemToAdd["nft_type_id"] = this.findID(
          this.props.nft_types,
          rawItem["nft_type"],
          "NFT_TYPE",
          a,
          "nft_type_id"
        ))
        : this.setState({
          error_message: "Nft_type is required",
          error_type: "danger",
        })
      // }

      // if (rawItem["ip"]) {
      rawItem["ip"]
        ? (itemToAdd["ip_id"] = this.findID(
          this.props.ips,
          rawItem["ip"],
          "IP",
          a,
          "ip_id"
        ))
        : this.setState({
          error_message: "ip is required",
          error_type: "danger",
        })
      // }

      if (rawItem["brand"]) {
        itemToAdd["brand_id"] = this.findID(
          this.props.brands,
          rawItem["brand"],
          "BRAND",
          a,
          "brand_id"
        )
      }

      if (rawItem["series"]) {
        itemToAdd["series_id"] = this.findID(
          this.props.series,
          rawItem["series"],
          "SERIES",
          a,
          "series_id"
        )
      }

      if (rawItem["edition"]) {
        // console.log(this.props.edition,"edition")
        itemToAdd["edition_id"] = this.findID(
          this.props.edition,
          rawItem["edition"],
          "EDITION",
          a,
          "edition_id"
        )
      }

      if (rawItem["set"]) {
        itemToAdd["set_id"] = this.findID(
          this.props.sets,
          rawItem["set"],
          "SET",
          a,
          "set_id"
        )
      } else {
        itemToAdd["set_id"] = null
      }

      if (rawItem["collection"]) {
        itemToAdd["art_collection_id"] = this.findID(
          this.props.artCollections,
          rawItem["collection"],
          "COLLECTION",
          a,
          "art_collection_id"
        )
      } else {
        itemToAdd["art_collection_id"] = null
      }

      if (rawItem["artist_name"]) {
        itemToAdd["artist_id"] = this.findID(
          this.props.artists,
          rawItem["artist_name"],
          "ARTIST",
          a,
          "artist_id"
        )
      } else {
        itemToAdd["artist_id"] = null
      }

      if (rawItem["genre"]) {
        itemToAdd["genre_id"] = this.findID(
          this.props.genre,
          rawItem["genre"],
          "GENRE",
          a,
          "genre_id"
        )
      } else {
        itemToAdd["genre_id"] = null
      }

      if (rawItem["asset"]) {
        itemToAdd["asset_id"] = this.findID(
          this.props.assets,
          rawItem["asset"],
          "ASSET",
          a,
          "asset_id"
        )
      } else {
        //imp, show error
      }

      if (rawItem["lobby_type"]) {
        itemToAdd["lobby_id"] = this.findID(
          this.props.lobby,
          rawItem["lobby_type"],
          "LOBBY",
          a,
          "lobby_id"
        )
      } else {
        //imp, show error
        this.show_imp_requ_field_missing_error(
          "lobby_type null in ItemCode : " + itemToAdd["code"]
        )
        // console.log("lobby_type not present", itemToAdd["code"]);
      }

      // itemToAdd["thumbnail_video_url"] = null
      if (rawItem["asset"] == "2D Animated") {
        // console.log("hello")
        itemToAdd["thumbnail_video_url"] = rawItem["thumbnail_video"]
          ? baseURL +
          itemThumbnailVideoPath +
          rawItem["thumbnail_video"].toLowerCase()
          : this.setState({
            error_message:
              "Thumbnail video URL is required in 2D Animated case",
            error_type: "danger",
          })
      } else {
        itemToAdd["thumbnail_video_url"] = null
      }

      // if (rawItem["dlc_type"]) {
      rawItem["dlc_type"]
        ? (itemToAdd["dlc_type_id"] = this.findID(
          this.props.dlc_types,
          rawItem["dlc_type"],
          "DLC_TYPE",
          a,
          "dlc_type_id"
        ))
        : this.setState({
          error_message: "Dlc Type is required",
          error_type: "danger",
        })
      // }

      const ext = rawItem["extension"].toLowerCase()
      const s3fileName = rawItem["s3_file_name"]
        ? rawItem["s3_file_name"].toLowerCase()
        : this.setState({
          error_message: "S3 File name is missing",
          error_type: "danger",
        })
      const thumbnail_name = rawItem["thumbnail"].toLowerCase()

      if (rawItem["asset"] == "2D Animated" || rawItem["asset"] == "2D") {
        itemToAdd["vr_url"] = null
        itemToAdd["vr_updated_url"] = null
        itemToAdd["quest_url"] = null
        itemToAdd["webgl_url"] = null

        if (NODE_ENV == "PRODUCTION") {
          itemToAdd["android_url"] =
            "https://tv-inventory.s3.eu-west-2.amazonaws.com/paramount/posters/3d/android/paramount_box.dlc"
          itemToAdd["ios_url"] =
            "https://tv-inventory.s3.eu-west-2.amazonaws.com/paramount/posters/3d/ios/paramount_box.dlc"
        } else {
          itemToAdd["android_url"] =
            "https://tv-inventory-dev.s3.ap-south-1.amazonaws.com/thegodfather/posters/3d/android/paramount_box.dlc"
          itemToAdd["ios_url"] =
            "https://tv-inventory-dev.s3.ap-south-1.amazonaws.com/thegodfather/posters/3d/ios/paramount_box.dlc"
        }
      } else {
        itemToAdd["vr_url"] =
          baseURL + itemModelPath + "vr/deprecated/" + s3fileName + ".pak"
        itemToAdd["vr_updated_url"] =
          baseURL + itemModelPath + "vr/updated/" + s3fileName + ".pak"
        itemToAdd["quest_url"] =
          baseURL + itemModelPath + "quest/" + s3fileName + ".pak"
        itemToAdd["webgl_url"] =
          baseURL + itemModelPath + "webgl/" + s3fileName + ".dlc"
        itemToAdd["android_url"] =
          baseURL + itemModelPath + "android/" + s3fileName + ".dlc"
        itemToAdd["ios_url"] =
          baseURL + itemModelPath + "ios/" + s3fileName + ".dlc"
      }

      itemToAdd["medium_thumbnail_url"] = null

      if (
        this.state.currentSheet == "tva" ||
        this.state.currentSheet == "amrita" ||
        this.state.currentSheet == "aswaa"
      ) {
        if (ext == ".gif") {
          if (
            rawItem["medium_thumbnail"] &&
            rawItem["medium_thumbnail"].trim() !== ""
          ) {
            itemToAdd["medium_thumbnail_url"] =
              baseURL +
              itemImgPath +
              "medium_thumbnail/" +
              rawItem["medium_thumbnail"]
          } else {
            // console.log("mp4 but no Medium_Thumbnail value")
          }
        }
      }

      if (ext == ".mp4") {
        if (
          rawItem["medium_thumbnail"] &&
          rawItem["medium_thumbnail"].trim() !== ""
        ) {
          itemToAdd["medium_thumbnail_url"] =
            baseURL +
            itemImgPath +
            "medium_thumbnail/" +
            rawItem["medium_thumbnail"]
        } else {
          // console.log("mp4 but no Medium_Thumbnail value")
        }
      }

      itemToAdd["thumbnail_url"] =
        baseURL + itemImgPath + "small/" + thumbnail_name
      itemToAdd["largeImageUrl"] =
        baseURL + itemImgPath + "large/" + rawItem["code"].toLowerCase() + ext

      itemToAdd["currency_id"] = 1
      itemToAdd["isTransferable"] = 1
      itemToAdd["isTradable"] = 1
      itemToAdd["isActive"] = 0

      items.push(itemToAdd)
    }
    this.setState({
      copyJson: true,
      textToCopy: JSON.stringify(items, undefined, 4),
    })
  }

  findID(array, toFind, type, index, property) {
    toFind = toFind.trim()
    for (var a = 0; a < array.length; a++) {
      if (toFind.toLowerCase() === array[a].name.toLowerCase()) {
        return array[a].id
      }
    }

    var errorsObj = this.state.ERRORS
    var found = false
    for (var error of errorsObj) {
      if (error.includes(toFind + " in " + type)) {
        found = true
      }
    }
    if (!found) {
      var toAdd = "lookup not found: " + toFind + " in " + type
      errorsObj.push(toAdd)
      this.setState({ ERRORS: errorsObj })

      var newlookup = {
        type: type,
        data: toFind,
        array: array,
        index: index,
        property: property,
      }
      var lookupsToAdd = this.state.lookupsToAdd
      lookupsToAdd.push(newlookup)
      this.setState({ lookupsToAdd: lookupsToAdd })
      this.setState({ isSetLookupsLocked: false })
    }
    return -1
  }

  login_url = {
    dev: {
      url: "http://dev.terravirtua.io:3003/admin/login",
      username: "admin",
      password: "axddfsa",
    },
    stag: {
      url: "https://awr3z1xgme.execute-api.ap-south-1.amazonaws.com/staging/admin/login",
      username: "admin",
      password: "",
    },
    prod: {
      url: "https://console.terravirtua.io/admin/login",
      username: "admin",
      password: "",
    },
    preprod: {
      url: "https://console.preprodterra.com/admin/login",
      username: "admin",
      password: "",
    },
  }

  setLookups() {
    this.setState({ isSetLookupsLocked: true })

    var accessToken = localStorage.getItem("token")
    var axios = require("axios")
    var data = JSON.stringify({ action: "lookup-parent" })

    var config = {
      method: "post",
      url: API_URL.ADMIN_TRADING_API + "lookups",
      headers: {
        Authorization: accessToken,
        "Content-Type": "application/json",
      },
      data: data,
    }

    axios(config)
      .then(async (response) => {
        var lookUps = response.data.payload.lookUp
        var errors = [],
          isLookupsLocked = true
        var items = JSON.parse(this.state.textToCopy)

        for (var a = 0; a < this.state.lookupsToAdd.length; a++) {
          var parentLookup = ""

          for (var b = 0; b < lookUps.length; b++) {
            var chkLookUP = this.state.lookupsToAdd[a].type.toLowerCase()

            if (chkLookUP == "brand") {
              chkLookUP = "brands"
            }
            if (chkLookUP == lookUps[b].name.toLowerCase()) {
              this.setState({
                SetLookupsActionStatus: "Creating: " + chkLookUP,
              })

              await this.checkIfLookupCreate(
                this.state.lookupsToAdd[a],
                lookUps[b],
                accessToken,
                axios
              ).then((response) => {
                if (response) {
                  var lookup = response.data.payload.lookup
                  var obj = this.state.lookupsToAdd[a]
                  var index = obj.index
                  var property = obj.property

                  items[index][property] = lookup.id
                  parentLookup = chkLookUP
                }
              })
              if (parentLookup) break
            }
          }

          if (!parentLookup) {
            const lookup = this.state.lookupsToAdd[a]
            isLookupsLocked = false
            errors.push(
              `Lookup [${lookup.data}] not created:<span> Parent lookup [${lookup.type}] not found</span>`
            )
          }
        }
        this.setState({
          lookupsToAdd: [],
          isSetLookupsLocked: isLookupsLocked,
          SetLookupsActionStatus: "",
          ERRORS: errors,
          copyJson: true,
          textToCopy: JSON.stringify(items, undefined, 4),
        })
      })
      .catch(function (error) {
        this.setState({ SetLookupsActionStatus: "Failed See Error" })
      })
  }

  checkIfLookupCreate = async (newLookup, parent, accessToken, axios) => {
    let self = this
    var data = JSON.stringify({
      action: "create",
      name: newLookup.data,
      description: newLookup.data,
      parentId: parent.id,
      value: "",
    })

    var config = {
      method: "post",
      url: API_URL.ADMIN_TRADING_API + "lookups",
      headers: {
        Authorization: accessToken,
        "Content-Type": "application/json",
      },
      data: data,
    }

    return await axios(config)
  }

  show_imp_requ_field_missing_error(type) {
    var errorsObj = this.state.ERRORS
    var toAdd = "Required Field: " + type
    errorsObj.push(toAdd)
    this.setState({ ERRORS: errorsObj })
  }

  showURLError(type) {
    var errorsObj = this.state.ERRORS
    var toAdd = "err: Lookup ID request - " + type
    errorsObj.push(toAdd)
    this.setState({ ERRORS: errorsObj })
  }

  resetForm = () => {
    $("#brands").val("none")
    $("#csv-file").val("")

    this.setState(
      {
        waitingForLookups: true,
        currentSheet: "none",
        copyJson: false,
        textToCopy: "",
        ERRORS: [],
        fileInfo: "",
        isSetLookupsLocked: true,
        lookupsToAdd: [],
        btnIsDisable: false,
        error_message: "",
        error_type: ""
      },
      () => this.getLookups()
    )
  }

  render() {
    const parserOptions = {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      transformHeader: (header) => this.handleHeader(header),
    }

    return (
      <>
        <div class="content create-json">
          <div class="top-header d-block">
            <div class="header-title">
              <h2 class="title">Create JSON</h2>
              <span class="title-caption">You can create JSON file here.</span>
            </div>
          </div>
          <div class="main-content">
            {this.state.error_message && (
              <Notification
                type={this.state.error_type}
                message={this.state.error_message}
                callback={this.removeNetworkError}
              />
            )}

            <form action="" class="json-form">
              <div class="form-group">
                <label for="jsonFileType">Select File</label> <br />

                <select class="form-select" aria-label="Default select example"
                  id="jsonFileType" onChange={this.onFileTypeSelection}
                >
                  <option value=""></option>
                  <option value="vflect">vflect</option>
                  <option value="los">los</option>
                  <option value="godfather">godfather</option>
                  <option value="sunset">sunset</option>
                  <option value="nerds">nerds</option>
                  <option value="comics">comics</option>
                  <option value="tva">tva</option>
                  <option value="amrita">amrita</option>
                  <option value="aswaa">aswaa</option>
                  <option value="topgun">topgun</option>
                  <option value="pacificrim">pacificrim</option>
                  <option value="godzilla_vs_kong">godzilla_vs_kong</option>
                  <option value="dynamite">dynamite</option>
                  <option value="locgame">locGame</option>
                  <option value="redbullracing">redBullRacing</option>
                  <option value="cardano">cardano</option>
                  <option value="isl">isl</option>
                  <option value='nitroleague'>nitroleague</option>
                  <option value='deathmerchant'>death merchant</option>

                </select>
              </div>

              <div class={`form-group ImgField ${this.state.waitingForLookups ? 'disabled' : ''}`}>
                <label class="imgFieldArea" for="csvFile">
                  <span class="icon fileImg">
                    {this.state.fileInfo ?
                      <div>{this.state.fileInfo.name}</div>
                      : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                          <path id="images" d="M6,2A4,4,0,0,0,2,6V18a4,4,0,0,0,4,4H18a4,4,0,0,0,4-4V6a4,4,0,0,0-4-4ZM6,4H18a2,2,0,0,1,2,2v8.737A4.142,4.142,0,0,0,17,13c-1.293,0-2.448.921-3.563,2.406-.054.072-.071.118-.124.191-.236-.689-.5-1.353-.782-2C11.282,10.737,9.876,9,8,9c-1.632,0-2.919,1.38-3.991,3.447L4,6A2,2,0,0,1,6,4Zm2,7c.749,0,1.781,1.263,2.719,3.406a26.167,26.167,0,0,1,.968,2.656c.1.318.331,1.133.344,1.188a1.006,1.006,0,0,0,1.875.188c.054-.107.16-.3.313-.563a13.537,13.537,0,0,1,.843-1.281C15.823,15.579,16.543,15,17,15s1.177.579,1.937,1.594a14.039,14.039,0,0,1,1.043,1.638A1.978,1.978,0,0,1,18,20H6a1.94,1.94,0,0,1-1.406-.594,1.984,1.984,0,0,1-.563-1.344c.063-.224.2-.733.281-1a26.414,26.414,0,0,1,.969-2.656C6.219,12.263,7.251,11,8,11Zm7-3a1,1,0,1,1,1,1A1,1,0,0,1,15,8Z" transform="translate(-2 -2)" />
                        </svg>
                      )}
                  </span>
                  Click here upload file
                </label>

                <CSVReader
                  cssClass="react-csv-input"
                  accept=".csv, text/csv"
                  inputId="csvFile"
                  cssInputClass="imgFieldArea"
                  inputName="csvFile"
                  onError={(error) => console.log(error)}
                  onFileLoaded={this.handleForce}
                  parserOptions={parserOptions}
                  inputStyle={{ visibility: 'hidden' }}
                />
              </div>

              <div class="content-btn">
                <button class="custom-btn sm-btn gradiant-btn"
                  onClick={() => this.setLookups()}
                  disabled={this.state.isSetLookupsLocked}
                >Set Lookups
                </button>
              </div>

              {this.state.ERRORS.length > 0 && (
                <div class="form-group">
                  Errors:
                  {this.state.ERRORS.map((item, i) => (
                    <p className="errors" key={i} dangerouslySetInnerHTML={{ __html: JSON.stringify(item) }} />
                  ))}
                </div>
              )}

              <div class="form-group">
                <label for="jsonItem">Item</label>
                <textarea id="jsonItem" rows="20"
                  value={this.state.textToCopy}
                  onChange={(e) => this.setState({ textToCopy: e.target.value })}
                >
                </textarea>
              </div>

              <div class="content-btn">
                <button type="reset" class="custom-btn sm-btn semi-dark-btn border-btn" onClick={this.resetForm}>Reset</button>
                {this.state.btnIsDisable ?
                  <LoadingButton class_name={"sm-btn"} />
                  :
                  <button type="submit" class="custom-btn sm-btn gradiant-btn"
                    disabled={this.state.copyJson && this.state.ERRORS.length == 0 ? false : true} onClick={(e) => this.onSave(e)}>{this.state.btnIsDisable ? "Loading..." : "Save"}
                  </button>
                }
              </div>
            </form>
          </div>
        </div>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    profile: state.profile,
    items: state.items,
    limit: state.itemMeta.limit,
    page: state.itemMeta.page,
    search: state.itemMeta.search,
    copies: state.itemCopies,
    total: state.itemCopiesMeta.total,
    copiesPage: state.itemCopiesMeta.page,
    copiesLimit: state.itemCopiesMeta.limit,
    copiesSearch: state.itemCopiesMeta.search,
    ips: state.ips,
    brands: state.brands,
    types: state.types,
    edition: state.editions,
    sets: state.sets,
    nft_types: state.nftTypes,
    dlc_types: state.dlcTypes,
    assets: state.assets,
    series: state.series,
    artists: state.artists,
    artCollections: state.artCollections,
    artists: state.artists,
    variations: state.variations,
    categories: state.categories,
    rarities: state.rarities,
    lobby: state.lobby,
    genre: state.genre,
    writer: state.writer,
    illustrator: state.illustrator,
  }
}

const mapDispatchToProps = {
  getAll,
  getCopies,
  fetchLookupParentsChild,
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateJSON)
